import { render, staticRenderFns } from "./tratamientoSesion.vue?vue&type=template&id=0f8ff5fd&scoped=true"
import script from "./tratamientoSesion.vue?vue&type=script&lang=js"
export * from "./tratamientoSesion.vue?vue&type=script&lang=js"
import style0 from "./tratamientoSesion.vue?vue&type=style&index=0&id=0f8ff5fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ff5fd",
  null
  
)

export default component.exports